// Store download cooldowns in localStorage
const DOWNLOAD_COOLDOWN_KEY = "download_cooldowns";

// Get all download cooldowns
export const getDownloadCooldowns = () => {
  const cooldowns = localStorage.getItem(DOWNLOAD_COOLDOWN_KEY);
  return cooldowns ? JSON.parse(cooldowns) : {};
};

// Set a download cooldown for a specific type and folders
export const setDownloadCooldown = (
  type,
  folders,
  resolution,
  faceSearchId = null
) => {
  const cooldowns = getDownloadCooldowns();
  let key;

  if (type === "face_search" && faceSearchId) {
    // For face search downloads, use faceSearchId as the unique identifier
    key = `${type}_${faceSearchId}_${resolution}`;
  } else {
    // For other downloads, use folders as before
    key = `${type}_${folders.join("_")}_${resolution}`;
  }

  cooldowns[key] = Date.now() + 15 * 60 * 1000; // 30 minutes from now
  localStorage.setItem(DOWNLOAD_COOLDOWN_KEY, JSON.stringify(cooldowns));
};

// Check if a download is on cooldown
export const isDownloadOnCooldown = (
  type,
  folders,
  resolution,
  faceSearchId = null
) => {
  const cooldowns = getDownloadCooldowns();
  let key;

  if (type === "face_search" && faceSearchId) {
    // For face search downloads, use faceSearchId as the unique identifier
    key = `${type}_${faceSearchId}_${resolution}`;
  } else {
    // For other downloads, use folders as before
    key = `${type}_${folders.join("_")}_${resolution}`;
  }

  const cooldownTime = cooldowns[key];

  if (!cooldownTime) return false;

  if (Date.now() > cooldownTime) {
    // Cooldown expired, remove it
    delete cooldowns[key];
    localStorage.setItem(DOWNLOAD_COOLDOWN_KEY, JSON.stringify(cooldowns));
    return false;
  }

  return true;
};

// Get remaining cooldown time in minutes
export const getRemainingCooldownTime = (
  type,
  folders,
  resolution,
  faceSearchId = null
) => {
  const cooldowns = getDownloadCooldowns();
  let key;

  if (type === "face_search" && faceSearchId) {
    // For face search downloads, use faceSearchId as the unique identifier
    key = `${type}_${faceSearchId}_${resolution}`;
  } else {
    // For other downloads, use folders as before
    key = `${type}_${folders.join("_")}_${resolution}`;
  }

  const cooldownTime = cooldowns[key];

  if (!cooldownTime) return 0;

  const remaining = Math.ceil((cooldownTime - Date.now()) / (60 * 1000));
  return remaining > 0 ? remaining : 0;
};
